module.exports = __webpack_public_path__ + "media/icon-arrow-left.c48fc6fe.svg";